const validFormatters = ['thousands', 'decimal'];
const delimiter = ',';

const formatThousand = (value) => {
    if (!value) return '';

    if (typeof value == 'number') {
        value = Math.trunc(value);
    }
    const formattedValue = value
        .toString()
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);

    return formattedValue;
};

const handleFormatter = (type, value, target = null) => {
    let formattedValue;
    if (type === 'thousands') {
        formattedValue = formatThousand(value);
    }

    if (target) {
        target.value = formattedValue;
    }

    return formattedValue;
};

export default {
    mounted: (el, binding) => {
        const formatter = binding.value;

        if (!validFormatters.includes(formatter)) {
            console.warn(`Invalid formatter: ${formatter}`);
            return;
        }

        if (formatter) {
            el.addEventListener('input', () => {
                handleFormatter(formatter, el.value, el);
            });
        }
    },
    unmounted: (el, binding) => {
        if (binding.value) {
            el.removeEventListener('input', () => {});
        }
    },
    format: (type, value) => {
        if (!validFormatters.includes(type)) {
            console.warn(`Invalid formatter: ${type}`);
            return;
        }

        return handleFormatter(type, value);
    },
    unformat: (value) => {
        if (!value) return '';

        return value.toString().replaceAll(delimiter, '');
    },
};
